import gql from 'graphql-tag'

export const GET_MY_TUTOR_TOKEN = gql`
  query GetMyTutorToken(
    $userId: String!
    $resumeConversation: Boolean
    $template: String
    $email: String
    $accountExpiresAt: String
    $userName: String
    $userType: String
    $targetLanguage: String
    $interfaceLanguage: String
    $forceUseProdEnv: Boolean
  ) {
    getMyTutorToken(
      myTutorTokenInput: {
        userId: $userId
        resumeConversation: $resumeConversation
        template: $template
        email: $email
        accountExpiresAt: $accountExpiresAt
        userName: $userName
        userType: $userType
        targetLanguage: $targetLanguage
        interfaceLanguage: $interfaceLanguage
        forceUseProdEnv: $forceUseProdEnv
      }
    ) {
      token
      expiry
      link
      conversationId
    }
  }
`

export const GET_MY_TUTOR_TOKEN_ALIAS = gql`
  query GetMyTutorToken(
    $userId: String!
    $resumeConversation: Boolean
    $template: String
    $targetLanguage: String
    $interfaceLanguage: String
  ) {
    getMyTutorToken(
      myTutorTokenInput: {
        userId: $userId
        resumeConversation: $resumeConversation
        template: $template
        targetLanguage: $targetLanguage
        interfaceLanguage: $interfaceLanguage
      }
    ) {
      token
      expiry
      link
      conversationId
    }
  }
`
